import { render, staticRenderFns } from "./ManageUnidade.vue?vue&type=template&id=60039cbb&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageUnidade.vue?vue&type=style&index=0&id=60039cbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60039cbb",
  null
  
)

export default component.exports